import { useGetPositionsOfAccountWithoutPaymentPrefQuery } from "../../../../../graphql/supergraph.index";
import { FETCH_MORE_POSITIONS_PER_PAGE, INITIAL_POSITIONS_PER_PAGE } from "../constants";

export type PositionListOfAccountWithoutPaymentPrefProps = {
  id: string;
};

export const usePositionListOfAccountWithoutPaymentPref = ({
  id,
}: PositionListOfAccountWithoutPaymentPrefProps) => {
  const {
    data,
    fetchMore: positionListFetchMore,
    error: positionListError,
    loading: positionListLoading,
    refetch: refetchPositionList,
  } = useGetPositionsOfAccountWithoutPaymentPrefQuery({
    variables: {
      id,
      first: INITIAL_POSITIONS_PER_PAGE,
      includeDeletedAccount: true,
    },
    fetchPolicy: "cache-and-network",
  });

  const positionsPaginated = data?.account?.positions ?? undefined;

  const handleLoadMorePositions = () => {
    if (!positionsPaginated?.pageInfo.hasNextPage) {
      return;
    }
    void positionListFetchMore({
      variables: {
        id,
        first: FETCH_MORE_POSITIONS_PER_PAGE,
        after: data?.account?.positions?.pageInfo.endCursor,
      },
      updateQuery(previousResult, { fetchMoreResult }) {
        if (!fetchMoreResult?.account?.positions) {
          return previousResult;
        }

        if (!previousResult.account?.positions) {
          return fetchMoreResult;
        }

        return {
          ...previousResult,
          account: {
            ...previousResult.account,
            id: previousResult.account.id,
            positions: {
              ...previousResult.account.positions,
              edges: [
                ...(previousResult?.account?.positions.edges ?? []),
                ...fetchMoreResult.account.positions.edges,
              ],
              pageInfo: fetchMoreResult.account?.positions.pageInfo,
            },
          },
        };
      },
    });
  };

  return {
    positionsPaginated,
    positionListLoading,
    positionListError,
    handleLoadMorePositions,
    refetchPositionList,
  };
};
